import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {requestInventoryReports} from "../../../redux/Actions/inventoryReports.action";
import {
  getInventoryReportsList,
  getInventoryReportsPaginationUrls,
  getInventoryReportsTotalCount,
} from "../../../redux/Selectors/inventoryReports.selector";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {inventoryReportsURL} from "./inventoryReportsTable.constants";

export const useInventoryReportsTableData = (onFiltersChange) => {
  const dispatch = useDispatch();
  const inventoryReports = useSelector(getInventoryReportsList);
  const paginationUrls = useSelector(getInventoryReportsPaginationUrls);
  const totalCount = useSelector(getInventoryReportsTotalCount);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(requestInventoryReports());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePagination = (page) => {
    const url = currentPage < page ? paginationUrls?.nextUrl : paginationUrls?.prevUrl;
    dispatch(requestInventoryReports(url));
    setCurrentPage(page);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePagination,
  };

  const handleSearch = (tokens) => {
    onFiltersChange(tokens);
    if (tokens?.length > 0) {
      dispatch(requestInventoryReports(generateQueryUrl(inventoryReportsURL, tokens)));
    } else {
      dispatch(requestInventoryReports());
    }
  };

  return {inventoryReports, handleSearch, paginationConfig, totalCount};
};
